// Toggles between price/buy-buttons and the Offerte Aanvragen modal
// based on the currently selected variant's option values. Activated on any
// <product-info data-quote-trigger-values="..."> element. The comma-separated
// trigger list comes from the Price block's "quote_variant_values" setting.

(function () {
  function parseTriggers(str) {
    return (str || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  function variantTriggersQuote(variant, triggers) {
    if (!variant || !Array.isArray(variant.options)) return false;
    var lowerTriggers = triggers.map(function (t) { return t.toLowerCase(); });
    for (var i = 0; i < variant.options.length; i++) {
      var optValue = (variant.options[i] || '').toLowerCase();
      for (var j = 0; j < lowerTriggers.length; j++) {
        // Partial, case-insensitive match so a short trigger like "Losgestort"
        // matches the full option value "Losgestort vanaf 10m³ (Offerte aanvragen)".
        if (optValue.indexOf(lowerTriggers[j]) !== -1) return true;
      }
    }
    return false;
  }

  function applyVisibility(productInfoEl, showQuote) {
    productInfoEl.querySelectorAll('[data-quote-toggle="commerce"]').forEach(function (el) {
      el.classList.toggle('hidden', showQuote);
    });
    productInfoEl.querySelectorAll('[data-quote-toggle="quote"]').forEach(function (el) {
      el.classList.toggle('hidden', !showQuote);
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    document.querySelectorAll('product-info[data-quote-trigger-values]').forEach(function (productInfoEl) {
      var triggers = parseTriggers(productInfoEl.dataset.quoteTriggerValues);
      if (!triggers.length) return;

      var sectionId = productInfoEl.dataset.section;

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== sectionId) return;
        applyVisibility(productInfoEl, variantTriggersQuote(event.data.variant, triggers));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
